import React from 'react';
import PropTypes from 'prop-types';
import P from '@deliveroo/consumer-component-library/components/P';
import LoadingIndicator from '@deliveroo/consumer-component-library/components/LoadingIndicator';
import i18n from '../../utils/i18n';
import LiveOrderIndicator from '../LiveOrderIndicator';

import styles from './styles.scss';

export default function OrderStatusIndicatorHeader({
  showLiveIndicator,
  showReconnecting,
  showLastUpdatedAt,
  statusTitle,
  uiStatus,
  formattedUpdatedAt,
  orderTrackerProgressAnimationFeatureOn,
}) {
  let statusIndicator;

  if (uiStatus === 'FAILED') {
    statusIndicator = <h3 className={styles.title}>{statusTitle}</h3>;
  } else {
    statusIndicator = (
      <div className={styles.live}>
        {!orderTrackerProgressAnimationFeatureOn &&
          showLiveIndicator &&
          !showReconnecting &&
          !showLastUpdatedAt && <LiveOrderIndicator />}
        {showReconnecting ? (
          <span className={styles.reconnecting}>
            <LoadingIndicator />
            <span className={styles.text}>
              <P size="small" isBold color="grey">
                {i18n.gettext('order_status_page.reconnecting_text')}
              </P>
            </span>
          </span>
        ) : (
          <P size="small" color="grey">
            {statusTitle}
          </P>
        )}
        {showLastUpdatedAt && (
          <div className={styles['last-updated']}>
            <P size="small" color="grey">
              {formattedUpdatedAt}
            </P>
          </div>
        )}
      </div>
    );
  }

  return <div className={styles['status-indicator-header']}>{statusIndicator}</div>;
}

OrderStatusIndicatorHeader.propTypes = {
  showLiveIndicator: PropTypes.bool.isRequired,
  showReconnecting: PropTypes.bool.isRequired,
  showLastUpdatedAt: PropTypes.bool.isRequired,
  statusTitle: PropTypes.string.isRequired,
  formattedUpdatedAt: PropTypes.string.isRequired,
  uiStatus: PropTypes.string.isRequired,
  orderTrackerProgressAnimationFeatureOn: PropTypes.bool.isRequired,
};
